<template>
	<div v-if="assetTransferForm" class="py-8">
		<Card>
			<template #content>
				<AssetTransferOwnershipForm
					:form="assetTransferForm"
					:asset-id="assetTransferForm?.id || $route.params.asset"
					:show-actions="true"
					:show-reset="false"
					@on-save="afterTransfer"
					@on-recover="confirmRecover"
					:is-deleted="assetTransferForm.is_deleted"
					:disabled="!$auth.hasPermission('update:assets')"
				/>
			</template>
		</Card>
	</div>
</template>

<script>
import AssetTransferOwnershipForm from "@/Forms/AssetTransfer/AssetTransferOwnershipForm.vue";
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";

export default {
	name: "AssetTransferOwnershipView",
	components: {AssetTransferOwnershipForm},
	data() {
		return {
			assetTransferForm: undefined,
		}
	},
	emits: [
		'on-save',
		'on-recover',
	],
	computed: {
		...mapStores(useAssetsStore)
	},
	methods: {
		async afterTransfer() {
			try {
				const assetId = this.assetTransferForm?.id || this.$route.params.asset;
				if (assetId) {
					// Refresh the asset form to reflect new ownership
					this.assetTransferForm = await this.assetsStore.editAsset(assetId);
				}
				this.$toast.add({
					severity: 'success',
					summary: this.$t('common.complete'),
					detail: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.asset_saved'),
					life: 3000
				});
				this.$emit('on-save');
				// Navigate to admin assets list after transfer
				this.$router.push({ name: 'admin.assets.transfers' });
			} catch (error) {
				// ignore
			}
		},
		confirmRecover() {
			this.$confirm.require({
				group: 'confirm',
				message: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.are_you_sure_you_want_to_recover_this_asset'),
				header: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.recover_asset'),
				accept: () => {
					this.recoverAsset();
				},
				reject: () => {
					this.$toast.add({
						severity: 'info',
						summary: this.$t('common.cancelled'),
						detail: this.$t('pages.admin.assets.assets.asset.properties.asset_properties_view.asset_was_not_recovered'),
						life: 3000
					});
				}
			});
		},
		async recoverAsset() {
			try {
				const assetId = this.assetTransferForm?.id || this.$route.params.asset;

				await this.assetsStore.recoverAsset(assetId);
				// Reload the asset form to reflect the restored state
				this.assetTransferForm = await this.assetsStore.editAsset(assetId);
				this.$emit('on-save');
				
			} catch (error) {
				console.log(error);
			}
		},

	},
	watch: {
		'$route.params.asset': {
			async handler(newValue, oldValue) {
				if(newValue){
          console.log(newValue)
					if(this.$route.params.asset === 'NEW'){
						this.assetTransferForm = await this.assetsStore.createAsset();
					} else {
						this.assetTransferForm = await this.assetsStore.editAsset(this.$route.params.asset);
					}
				} else {
					this.assetTransferForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>
